import { IUnitsRepository } from 'shared/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisUnitsRepository from './implementations/VectisUnitsRepository';

let instance: IUnitsRepository | null;

export default function makeUnitsRepository() {
  if (!instance) {
    const provider = makeHTTPProvider();

    instance = new VectisUnitsRepository(provider);
  }

  return instance;
}
